<div class="uk-offcanvas-content">
  <nav
    id="main-navigation"
    class="nav vertical"
    [attr.aria-label]="'Main navigation' | ai: 'ARIA_MAIN_NAV' | async">
    <div class="gamemenu">
      <div class="menu-block">
        @if (sideNav.opened) {
          <h2 class="sr-only">{{ 'Main menu' | ai: 'NAV_HEADING_MAIN' | async }}</h2>
          <ul class="stagger" *ifOnDom [@animateStagger]="'50'" role="list">
            @for (item of pagesMenu; track item) {
              <li class="item" [@slideIn]="'right'">
                <a
                  matSidenavToggler="game-menu"
                  class="menu-link"
                  [style.color]="item.color"
                  [routerLink]="[item.url]"
                  [state]="{ from: router.url }"
                  routerLinkActive="active"
                  #rla="routerLinkActive"
                  [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
                  [attr.aria-current]="rla.isActive ? 'page' : null"
                  matRipple>
                  <span class="menu-link-title" [translate]="item.translate"></span>
                </a>
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </nav>
</div>
